<template>
  <!-- 确认计划订单页面 -->
  <div class="confirmOrderPage">
    <!-- 内容区域 -->
    <section class="contentWrap">
      <div class="cardBox" v-for="(item, index) in cartData" :key="index">
        <div class="titleBox">
          <van-row class="titleRow">
            <span class="title"><img :src="titleIcon" class="iconImg" />{{ item.title }}</span>
          </van-row>
        </div>
        <div class="orderItemBox" v-for="(orderItem, index) in item.list" :key="index">
          <van-row class="orderIfnRow">
            <!-- 计划信息卡片 -->
            <ConfirmOrderCard :data="orderItem" :priceWeight="true" :profile="profiles" @getProfile="getProfile" />
          </van-row>
        </div>
      </div>
    </section>

    <van-overlay :show="isShowLoad" z-index="10000">
      <div class="wrapper" @click.stop>
        <van-loading size="24px" vertical>数据提交中...</van-loading>
      </div>
    </van-overlay>
  </div>
  <!-- 底部按钮 -->
  <section class="bottomWrap">
    <!-- 服务协议弹窗 -->
    <PopUp :showPopUp="showPopUps" :datas="contractDatas" :lockScroll="false">
      <ServiceDeal :datas="contractDatas.contents" />
      <div class="popempty"></div>
    </PopUp>
    <!-- 产品告知书暂时注释 -->
    <!-- <van-row class="fvlr agreeBox">
      <van-col span="24">
        <van-checkbox v-model="isAgree2" shape="square" checked-color="#3088c5"> </van-checkbox>
        <span class="severPactionBox"> 本人同意<span class="severPaction" @click="viewContract">商品告知书</span></span>
      </van-col>
    </van-row> -->
    <van-row class="fvlr agreeBox">
      <van-col span="24">
        <van-checkbox v-model="isAgree" shape="square" checked-color="#3088c5"> </van-checkbox>
        <span class="severPactionBox"> 本人同意<span class="severPaction" @click="showPopUps += 1">用户服务协议</span></span>
      </van-col>
    </van-row>
    <van-row>
      <van-col span="24">
        <div v-if="!isIntention" class="header">
          已更新为经销商为您提供的最终优惠售价
        </div>
        <div v-else class="header">
          *本次付款操作为支付意向金，请预约经销商进店
        </div>
      </van-col>
    </van-row>
    <van-row class="fvlr">
      <van-col span="14"
        >共{{ totalProductAmount }}件 合计: ￥<span class="price"> {{ totalPrice }}</span></van-col
      >
      <van-col span="10">
        <div :class="['sub', isDisableBtn ? 'disableBtn' : '']" @click="subOrder">
          {{ isIntention ? '支付意向金' : '去购买' }}
        </div>
      </van-col>
    </van-row>
    <ContractServiceDeal :showPopUp="showPopUp" :datas="contractData" />
    <teleport to="#app">
      <SubmitOrder ref="showSubmitOrderPopUp" />
    </teleport>
  </section>
</template>

<script>
import { reactive, toRefs, onMounted, watch, nextTick, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ConfirmOrderCard from '@/components/order/ConfirmOrderCard'
import ContractServiceDeal from '@/components/directSales/ContractServiceDeal'
import PopUp from '@/components/common/PopUp'
import { useStore } from 'vuex'
import { addOrder } from '@/api/order'
import { Toast } from 'vant'
import SubmitOrder from '@/components/order/SubmitOrder.vue'
import ServiceDeal from '@/components/common/serviceDeal'
import { contractData, planContractData, tyreContractData } from '@/assets/js/tyreContract'
import useContractServiceDealFn from '@/hooks/directSales/useContractServiceDeal'
import { isNum } from '@/util/index'
import _ from 'lodash'

export default {
  components: {
    ContractServiceDeal,
    ConfirmOrderCard,
    PopUp,
    SubmitOrder,
    ServiceDeal
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    let { loyaltyType, qrData = {} } = store.state.currentGoodsInfo
    let bugGooodsInfo = store.state.currentBuyProductInfo
    const { viewContractServiceDealFn, showPopUp, contractData } = useContractServiceDealFn()
    const state = reactive({
      titleIcon: loyaltyType == 2 ? require('../../../assets/images/tyreplanIcon.png') : require('../../../assets/images/handShake.png'),
      cartData: [],
      popUpcontent: {
        title: '服务协议',
        content: '服务协议服务协议服务协议服务协议服务协议服务协议服务协议'
      },
      isIntention: bugGooodsInfo?.intention,
      contractDatas: loyaltyType == 2 ? tyreContractData : planContractData,
      showPopUps: false,
      isAgree: false,
      isAgree2: false,
      totalPrice: 0,
      totalProductAmount: 0,
      queryFrom: '',
      // {1:购物车入口请求,2:立即购买}
      typeFlag: '',
      orderNo: '',
      //支付方式标识{1:支付宝，2:微信}
      payMethodFlag: 1,
      subIng: false,
      isShowLoad: false,
      profiles: '',
      name: ''
    })
    const showSubmitOrderPopUp = ref()
    const getProfile = val => {
      state.profiles = val
    }
    // 获取提交数据
    const getSubParam = () => {
      const { typeFlag, queryFrom } = state
      const { boUserInfo, brandInfo, currentCarInfo } = store.state
      const bugGooodsInfo = store.state.currentBuyProductInfo
      const { orderSource, qrcodeHistoryId, scanTypeFlag } = store.state.currentGoodsInfo
      //let payTypeFlag = bugGooodsInfo.payTypeFlag
      let payTypeFlag = ''
      if (bugGooodsInfo.intention) {
        //新增意向金
        payTypeFlag = 3
      }
      let data = {
        payTypeFlag,
        typeFlag,
        plan: { data: [] },
        roleCode: qrData?.roleCode || '',
        roleName: qrData?.roleName || '',
        d8Account: qrData?.d8Account || '',
        salesName: qrData?.salesName || '',
        salesChannel: qrData?.salesChannel || ''
      }
      if (!currentCarInfo?.id) {
        data.payTypeFlag = 3
      }
      data.boUserId = boUserInfo.id
      data.orderSource = orderSource
      data.qrcodeHistoryId = qrcodeHistoryId || ''
      data.scanTypeFlag = scanTypeFlag || ''
      data.profile = state.profiles
      // 来自商品详情
      if (queryFrom === 'commodityDetails') {
        let { num: productAmount, loyaltyId: productId, productType, price, gsCode, customerCarId, selfPrice, boUserId = '' } = bugGooodsInfo
        let productPrice = isNum(selfPrice) ? selfPrice : price
        if (bugGooodsInfo.intention) {
          //新增意向金
          productPrice = bugGooodsInfo.depositPrice
        }
        data.boUserId = boUserId
        data.plan.data = [
          {
            productAmount,
            productId,
            productType,
            productPrice,
            gsCode,
            customerCarId,
            brand: brandInfo?.brand,
            spec: brandInfo?.spec,
            productNo: brandInfo?.productNo,
            productTypeFlag: brandInfo?.proItem?.partType || '',
            menuBaumuster: brandInfo?.proItem?.baumuster || '',
            baumuster: brandInfo?.proItem?.baumuster || '',
            finStart: brandInfo?.proItem?.finStart || '',
            finEnd: brandInfo?.proItem?.finEnd || ''
          }
        ]
      }

      // 来自购物车
      if (queryFrom === 'shoppingCarList') {
        let arr = bugGooodsInfo.tyrePlanData && bugGooodsInfo.tyrePlanData.length ? bugGooodsInfo.tyrePlanData : bugGooodsInfo.planData
        data.plan.data = [...arr].map(item => {
          const {
            productId,
            productType,
            uniformPrice,
            id: cartId,
            gsCode,
            customerCarId,
            selfPrice,
            brand,
            spec,
            productNo,
            productTypeFlag,
            finStart,
            finEnd,
            menuBaumuster,
            baumuster
          } = item._data
          const { num: productAmount } = item
          let productPrice = isNum(selfPrice) ? selfPrice : uniformPrice
          //新增意向金 直接取selfPrice
          if (item._data.payTypeFlag == 3) {
            productPrice = item.selfPrice
          }
          return {
            productAmount,
            productId,
            productType,
            productPrice,
            cartId,
            gsCode,
            customerCarId,
            brand,
            spec,
            productNo,
            productTypeFlag,
            menuBaumuster,
            baumuster,
            finStart,
            finEnd
          }
        })
      }
      return { data }
    }
    const isDisableBtn = computed(() => {
      return !state.isAgree || state.subIng || state.orderNo
    })
    watch(
      () => store.state.registerUserInfo,
      v => {
        state.name = v?.username || ''
      },
      { immediate: true, deep: true }
    )

    const viewContract = () => {
      let { currentNotificationData } = store.state
      console.log(currentNotificationData)
      if (!state.name) {
        Toast('联系人姓名缺失，请完善联系人信息')
        return
      }
      try {
        let option = { ...currentNotificationData, contactName: state.name }
        viewContractServiceDealFn(option)
      } catch (error) {
        Toast('数据有误')
      }
    }

    // 提交订单数据
    const subOrder = _.debounce(async () => {
      if (isDisableBtn.value) return
      state.subIng = true
      let param = getSubParam()
      if (!param) return
      state.isShowLoad = true
      try {
        const res = await addOrder(param)
        state.isShowLoad = false
        state.subIng = false
        state.orderNo = res.orderNo
        store.dispatch('getCountOfShoppingCar')
        // 0元订单，直接进入待完成状态，潘静又又改需求了，要跳转到订单列表页面
        if (res.orderStatusFlag === 3) {
          router.replace({ path: '/orderList', query: { status: 2 } })
          return
        }
        nextTick(() => {
          showSubmitOrderPopUp.value.chosePayType({ orderNo: res.orderNo })
        })
      } catch (e) {
        Toast({ message: e.message || '订单提交失败', position: 'bottom' })
        state.subIng = false
        state.isShowLoad = false
      }
    }, 300)

    onMounted(() => {
      // 来自商品详情
      if (route.query.from === 'commodityDetails') {
        state.cartData = [
          {
            title: loyaltyType == 2 ? '轮胎套餐计划' : '致友计划',
            list: [bugGooodsInfo]
          }
        ]
        // {1:购物车入口请求,2:立即购买}
        state.typeFlag = 2
        // console.log('totalPrice', bugGooodsInfo)
        if (state.isIntention) {
          state.totalPrice = Math.round(bugGooodsInfo.num * bugGooodsInfo.depositPrice * 100) / 100
        } else {
          state.totalPrice = Math.round(bugGooodsInfo.num * bugGooodsInfo.selfPrice * 100) / 100
        }
        state.totalProductAmount = bugGooodsInfo.num
      }
      // 来自购物车
      if (route.query.from === 'shoppingCarList') {
        let bugGooodsInfo = store.state.currentBuyProductInfo
        let tempData = []
        bugGooodsInfo.planData && bugGooodsInfo.planData.length && tempData.push({ title: '致友计划', list: bugGooodsInfo.planData })
        bugGooodsInfo.tyreData && bugGooodsInfo.tyreData.length && tempData.push({ title: '轮胎', list: bugGooodsInfo.tyreData })
        bugGooodsInfo.tyrePlanData &&
          bugGooodsInfo.tyrePlanData.length &&
          tempData.push({
            title: '轮胎套餐计划',
            list: bugGooodsInfo.tyrePlanData
          })
        state.cartData = tempData
        // {1:购物车入口请求,2:立即购买}
        state.typeFlag = 1
        // 改了，只有致友计划结算走本页面，轮胎结算走其他页面
        if (bugGooodsInfo.tyrePlanData && bugGooodsInfo.tyrePlanData.length > 0) {
          state.totalPrice = bugGooodsInfo.tyrePlanData.reduce((num, item) => {
            return Math.round(num * 100 + Number(item.num) * (Number(item.selfPrice) * 100)) / 100
          }, 0)
        } else {
          state.totalPrice = bugGooodsInfo.planData.reduce((num, item) => {
            // console.log('totalPrice', item)
            return Math.round(num * 100 + Number(item.num) * (Number(item.selfPrice) * 100)) / 100
          }, 0)
        }
        state.totalProductAmount = bugGooodsInfo.totalProductAmount
      }
      state.queryFrom = route.query.from
      state.orderNo = ''
      // state.name = store.state.currentContacts?.currentUser?.name || ''
    })
    return {
      ...toRefs(state),
      getProfile,
      viewContract,
      contractData,
      showPopUp,
      subOrder,
      showSubmitOrderPopUp,
      isDisableBtn
    }
  }
}
</script>

<style lang="scss" scoped>
.confirmOrderPage {
  background-color: #f5f5f5;
  color: #666666;
  font-size: 12px;
  :deep(.van-checkbox__icon) {
    font-size: 14px;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.header {
  height: 24px;
  color: #fff;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  background-color: orange;
}
.contentWrap {
  margin: 16px 0 80px;
  background-color: #fff;
  text-align: left;
  margin-bottom: calc(constant(safe-area-inset-bottom) + 100px);
  margin-bottom: calc(env(safe-area-inset-bottom) + 100px);
  // margin-bottom: 30px;
}
.orderItemBox {
  padding: 5px 10px;
}
.orderIfnRow {
  padding: 10px 10px 20px;
  border-bottom: 1px solid #ccc;
}
.orderItemBox:last-child .orderIfnRow {
  border-bottom: none;
}
.bottomWrap {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 136px;
  background-color: #fff;
  line-height: 48px;
  font-weight: 600;
  font-size: 14px;
  color: #666;
  z-index: 1;
  vertical-align: middle;
  :deep(.van-checkbox) {
    padding-left: 20px;
    vertical-align: middle;
  }
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.titleBox {
  margin: 0 10px;
  padding: 0 10px;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
}
.titleRow {
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  color: #333;
  vertical-align: middle;
  .title {
    font-weight: 600;
  }
}
.iconImg {
  width: 18px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
}
.agreeBox {
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  // border-bottom: 1px solid #ccc;
  vertical-align: middle;
  text-align: left;
  :deep(.van-checkbox) {
    display: inline-block;
    margin-right: 16px;
  }
}
.severPaction {
  color: #3088c5;
  text-decoration: underline;
  text-decoration-color: #3088c5;
}
.price {
  font-weight: 600;
  font-size: 16px;
  color: #3088c5;
}
.sub {
  color: #fff;
  background-color: #3088c5;
}
.disableBtn {
  opacity: 0.4;
}
.popempty {
  height: 65px;
  // border: 1px solid red;
}
</style>
